import React from 'react';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from '../../../types';

const required = (value) => (value ? undefined : 'Required');

const IndustryDescription = ({ options, isSubmitted, values, onChange }) => (
  <Content>
    {({ industryDescription, radioFieldErrorMessage }) => (
      <Field name="industryDescription" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="industryDescription"
            title={industryDescription}
            validationMessage={
              (isSubmitted || touched) && !values && !!error ? radioFieldErrorMessage : ''
            }
          >
            <Field name="industryDescription" validate={required}>
              {({ input }) => (
                <GenericSelect
                  name="industryDescription"
                  selectedId={!values ? null : values}
                  items={options}
                  onChange={(selectedId) => {
                    input.onChange(selectedId);
                    onChange('industryDescription', selectedId);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

IndustryDescription.propTypes = {
  options: PropTypes.shape({})
};

IndustryDescription.defaultProps = {
  options: {}
};

export default IndustryDescription;
